import { C } from '../theme'
import { RevealStagger } from './Reveal'
import { useContent } from '../content/ContentContext'
import { mediaAlt, mediaUrl } from '../content/derive'

export function About() {
  const about = useContent().home.about ?? {}
  const imageUrl = mediaUrl(about.image)

  return (
    <section id="nosotros" aria-label={about.eyebrow ?? 'Nuestra historia'} className="sec" style={{ padding: '104px 40px', background: '#fff' }}>
      <RevealStagger
        className="stack"
        style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}
      >
        <div style={{ position: 'relative' }}>
          {imageUrl && (
            <div style={{ borderRadius: '220px 220px 10px 10px', overflow: 'hidden', height: 540, boxShadow: '0 24px 60px rgba(21,35,63,.18)' }}>
              <img src={imageUrl} alt={mediaAlt(about.image, about.imageAlt)} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
            </div>
          )}
          {(about.badgeNumber || about.badgeLabel) && (
            <div style={{ position: 'absolute', bottom: -24, left: -24, background: '#fff', border: '1px solid rgba(193,39,45,.18)', padding: '18px 26px', borderRadius: 6, boxShadow: '0 14px 34px rgba(21,35,63,.14)' }}>
              <div style={{ fontFamily: "'Spectral',serif", fontSize: 34, color: C.red, lineHeight: 1 }}>{about.badgeNumber}</div>
              <div style={{ fontSize: 13, color: C.body, marginTop: 4 }}>{about.badgeLabel}</div>
            </div>
          )}
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', color: C.red, marginBottom: 18 }}>
            {about.eyebrow}
          </div>
          <h2 style={{ fontFamily: "'Spectral',serif", fontWeight: 400, fontSize: 44, lineHeight: 1.1, margin: '0 0 8px', color: C.ink, letterSpacing: '-.01em' }}>
            {about.title}
          </h2>
          <p style={{ fontFamily: "'Spectral',serif", fontStyle: 'italic', fontSize: 17, color: C.muted, margin: '0 0 24px' }}>
            {about.subtitle}
          </p>
          <p style={{ fontSize: 16.5, lineHeight: 1.72, color: C.body, margin: '0 0 28px' }}>
            {about.body}
          </p>
          {about.ctaLabel && (
            <a href="#contacto" style={{ color: C.blue, fontWeight: 700, fontSize: 15, textDecoration: 'none', borderBottom: `2px solid ${C.blue}`, paddingBottom: 3 }}>
              {about.ctaLabel}
            </a>
          )}
        </div>
      </RevealStagger>
    </section>
  )
}
